/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Cc_Position_Top_CenterInputs */



/**
* | output |
* | --- |
* | "Position Events to the top center of the video" |
*
* @param {Shortcut_Keys_Desc_Cc_Position_Top_CenterInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_cc_position_top_center = /** @type {((inputs?: Shortcut_Keys_Desc_Cc_Position_Top_CenterInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Cc_Position_Top_CenterInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Positionner les evenements en haut au centre de la video")
	if (locale === "de") return /** @type {LocalizedString} */ ("Positionieren Sie die Ereignisse oben in der Mitte des Videos.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Posiziona gli eventi in alto al centro del video")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Разместите события в верхней центральной части видео.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Colocar eventos en la parte superior central del vídeo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将事件定位到视频顶部中心位置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントをビデオの上部中央に配置する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो के शीर्ष केंद्र में इवेंट्स की स्थिति निर्धारित करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Posicione os eventos no centro superior do vídeo.")
	return /** @type {LocalizedString} */ ("Position Events to the top center of the video")
});